/** @format */

import { Container, Row } from "react-bootstrap";
import JobPostingForm from "./job-posting-form";

const JobPosting = () => {
  return (
    <>
      <div id="content-page" className="content-inner">
        <Container>
          <Row className="gx-4">
            <JobPostingForm />
          </Row>
        </Container>
      </div>
    </>
  );
};

export default JobPosting;
